module.exports = __webpack_public_path__ + "img/医药-决明子.d803a0f8.jpg";